import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';

@Component({
  selector: 'app-referred-terms',
  templateUrl: './referred-terms.component.html',
  styleUrls: ['./referred-terms.component.sass']
})
export class ReferredTermsComponent implements OnInit {
  public fileURL = "../../assets/pdf/Términos y Condiciones Programa Refiere y Gana Revisado regla GPON VoBO Marketing.pdf";
  public checkTerms;
  constructor(private loadingScreenService: LoadingScreenService, public matDialogRef: MatDialogRef<ReferredTermsComponent>, private services: Service, private global: GlobalService, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router) { 
    if (data.checkTerms != undefined) {
      this.checkTerms = data.checkTerms;
    }
  }
  ngOnInit() {
  }
  public close() {
    this.matDialogRef.close('accept');
  }
  getPdf = function (data) {
    window.open(this.fileURL);
  };
}